<template>
  <div @click="closeVideosList" v-if="isLibraryUpdated">
    <button @click="returnToPreviousScreen" class="close-x">
      <img class="close-icon" src="@/assets/images/close_icon.svg" alt="">
    </button>
    <uppy-uploads
      @closeUppy="openAndCloseUppy"
      v-if="isUppyOpen"
      :uploadType="uploadType"
      id="uppy"
      class="uppy-main"
    ></uppy-uploads>
    <generic-content-upload
      v-if="componentToDisplay === 'genericContentUpload'"
      @openUppy="openAndCloseUppy"
      @closeVideosList="closeVideosList"
      @openClasseUnitSearch="toggleComponent('unitSearch')"
    >
      <section class="content public">
        <h1 class="public-title">
          {{ getTitle }}
        </h1>
        <component
          :is="headerComponentName"
          @openClasseUnitSearch="toggleComponent('unitSearch')"
          @openUppy="openAndCloseUppy"
        ></component>
      </section>
    </generic-content-upload>
    <classe-unit-search
      v-else
      @openGenericContentUpload="toggleComponent('genericContentUpload')"
    ></classe-unit-search>
  </div>
</template>

<script>
import GenericContentUpload from '@/components/generic-content-upload'
import ClasseUnitSearch from '@/components/classe-unit-search'
import { mapState, mapActions } from 'vuex'
import FileUploadHeader from '@/components/file-upload-header'
import YoutubeUploadHeader from '@/components/youtube-upload-header'
import VideoUploadHeader from '@/components/video-upload-header'
import ClasseUploadHeader from '@/components/classe-upload-header'
import UrlUploadHeader from '@/components/url-upload-header'
import UppyUploads from '@/components/uppy-uploads'
import audioUploadHeader from '@/components/audio-upload-header'
import embeddedAudioUploadHeader from '@/components/embedded-audio-upload-header'

export default {
  components: {
    audioUploadHeader,
    embeddedAudioUploadHeader,
    ClasseUnitSearch,
    GenericContentUpload,
    FileUploadHeader,
    YoutubeUploadHeader,
    ClasseUploadHeader,
    UppyUploads,
    UrlUploadHeader,
    VideoUploadHeader
  },
  data () {
    return {
      componentToDisplay: null,
      isUppyOpen: false,
      uploadType: null,
      routeName: this.$route.name
    }
  },
  created () {
    if (this.$route.name !== 'edit-collection') {
      this.$store.dispatch('selectEntry', null)
    }
    if (this.routeName === 'uploads' && this.$route.params.type === 'classe') {
      this.componentToDisplay = 'unitSearch'
    } else {
      this.componentToDisplay = 'genericContentUpload'
    }
    const type = this.$route.params.type
    this.$store.dispatch('setUploadTitle', type)
  },
  computed: {
    ...mapState({
      selectedEntryOrigin: state => state.collections.selectedEntryOrigin,
      title: state => state.uploads.title,
      videoListDisplay: state => state.youtube.videoListDisplay,
      isLibraryUpdated: state => state.base.libraryDataUploaded

    }),
    headerComponentName () {
      const type = this.$route.params.type
      return type + '-upload-header'
    },
    getTitle () {
      return this.$route.name === 'edit-collection' ? this.$t('EDIT_CONTENT') : this.$t(this.title)
    }
  },
  methods: {
    ...mapActions(['resetUploadData']),
    closeVideosList () {
      if (this.$route.params.type === 'youtube' && this.videoListDisplay) {
        this.$store.dispatch('setVideoListDisplay', false)
      }
    },
    toggleComponent (component) {
      this.componentToDisplay = component
    },
    returnToPreviousScreen () {
      if (this.componentToDisplay === 'genericContentUpload') {
        this.resetUploadData()
      }
      this.$router.go(-1)
    },
    openAndCloseUppy (type) {
      this.uploadType ? this.uploadType = null : this.uploadType = type
      this.isUppyOpen = !this.isUppyOpen
    }
  },
  watch: {
    isLibraryUpdated: function () {
      if (this.isLibraryUpdated) {
        const idOfEntry = parseInt(this.$route.params.id)
        this.$store.dispatch('findAndSetEntryById', idOfEntry)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
